import { BaseContext } from "../../../utils/basecontext";
import { HttpClient } from "../../../utils/httpclient/httpclient";
import { POST} from '../api';
import { SixdeeCRBTAPI } from "../sixdeecrbtapi";
import { ShuffleRequest } from "./shufflerequest";
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class ShuffleActivationAndDeactivationAPI extends SixdeeCRBTAPI<ShuffleRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        //language
        //0 - English, 1 - Burmese--Different from other place bcoz MW is expecting mentioned
        // langugae Id to show the contents based on language
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/list-tones
        // return "list-tones"+"?"+"language="+ (this.getRequest().getListTonesRequest().getLanguage() === LanguageConst.ENGLISH ? "0": "1")+"&"+
        //        "msisdn="+ this.getRequest().getListTonesRequest().getMsisdn()+"&"+
        //        "startIndex="+ this.getRequest().getListTonesRequest().getStartIndex()+"&"+
        //        "endIndex="+ this.getRequest().getListTonesRequest().getEndIndex()+"&"+
        //        "rbtMode="+ this.getRequest().getListTonesRequest().getRbtMode();
        return "shuffle-activation-deactivation";
    }
    getRequestData()
    {
        return "aPartyMsisdn=" + this.getRequest().getShuffleRequest().getAPartyMsisdn() +"&"+
        "identifier="+ this.getRequest().getShuffleRequest().getIdentifier()+"&"+
       "language="+ (this.getRequest().getShuffleRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2");
    }
}





// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/shuffle/shuffleactivationdeactivationapi.tsx